import React, {Component} from 'react';
import './index.scss';

export default class MoreComment extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {

  }

  //返回回复评论值
  getBackComment = (data) => {
    if (data.at_user_name) {  //显示@
      return `回复@${data.at_user_name}：${data.content}`
    } else {   //不显示@
      return data.content
    }
  }

  render() {
    const {moreComment, mainComment} = this.props
    return <div className="back_bg">
      <div className="moreComment_box">
        <div className="moreBox_top">
          <div className="closeBtn" onClick={this.props.closeMore}></div>
        </div>
        <div className="moreBox_content">
          <div className="commentBox mainComment">
            <img src={mainComment.head_image} alt="头像" className="commentHead"/>
            <div className="weibo_icon"></div>
            <div className="mainComment_right">
              <p className="comment_user">{mainComment.user_name}</p>
              <p className="comment_addTime">{mainComment.add_time}</p>
              <p className="comment_content">{mainComment.content}</p>
            </div>
            <div className="clear"></div>
          </div>
          {moreComment.length > 0 ?
            moreComment.map((item, index) => {
              return <div className="commentBox itemCommetnBox" key={index}>
                <img src={item.head_image} alt="头像" className="commentHead"/>
                {item.data_from / 1 === 3 ?
                  <div className="weibo_icon"></div> : ''}
                <div className="mainComment_right">
                  <p className="comment_user">{item.user_name}</p>
                  <p className="comment_addTime">{item.add_time}</p>
                  <p className="comment_content">{this.getBackComment(item)}</p>
                </div>
                <div className="clear"></div>
                {index < moreComment.length - 1 ?
                  <div className="itemLine"></div> : ''
                }
              </div>
            }) : ''
          }
        </div>
      </div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/pages/Detail/MoreComment/index.js